import React from 'react'
import * as Comp from './input-credit-card-field.styles'

import type {
  NativeSyntheticEvent,
  TextInput,
  TextInputFocusEventData,
} from 'react-native'
import { useInputCreditCardProps } from '../../hooks'
import type { IInputCreditCardProps } from '../../types'

export const InputCreditCardField = React.forwardRef<
  TextInput,
  IInputCreditCardProps
>(({ onFocus, ...props }, ref) => {
  const {
    id,
    size,
    inputValue,
    disabled,
    readonly,
    isActive,
    setIsActive,
    onChangeText,
  } = useInputCreditCardProps()

  const handleFocus = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    setIsActive(true)
  }

  const handleBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    setIsActive(false)
  }

  const onFormatChange = (value: string) => {
    const onlyNumbers = value.replace(/\D/g, '').trim()
    const creditCardFormat = onlyNumbers.replace(/(\d{4})(?=\d)/g, '$1 ')

    if (onChangeText) onChangeText(creditCardFormat)
  }

  const isDisabled = disabled || readonly
  const isEditable = !isDisabled || !readonly

  return (
    <Comp.Field
      {...props}
      ref={ref}
      size={size}
      onFocus={handleFocus}
      keyboardType="numeric"
      maxLength={19}
      onBlur={handleBlur}
      onChangeText={onFormatChange}
      value={inputValue}
      aria-label={id}
      nativeID={id}
      cursorColor="black"
      editable={isDisabled ? false : isEditable}
      disabled={isDisabled}
      readonly={readonly}
      isActive={isActive}
    />
  )
})
